<template>
  <div
    id="page"
    class="
      xl:w-4/5
      md:w-11/12
      xl:my-3
      md:my-2
      md:mx-auto
      m-1
      bg-gray-50
      rounded
      animate-fade-in-down-op
    "
  >
    <div class="p-2 text-black font-bold text-center" id="main-box">
      <i class="fas fa-address-card font-bold my-1 p-2 mr-1 text-l"></i>
      My Selection
      <div class="border-b-2 border-rhulorange" />
    </div>

    <div class="mb-content text-black text-sm md:text-base">
      <div class="student-h3">Selection Availability:</div>
      <ul id="availability-section">
        <li class="enabled_msg" v-if="noProgramme">
          Choices disabled: could not determined your programme. During
          summer this may happen if you have not yet progressed.
        </li>
        <div v-else>
          <li class="enabled_msg">
            <span v-if="currentYearEnabled">&#10004;</span>
            <span v-else>&#10007;</span>
            Current year: {{ currentYearMessage }}
          </li>
          <li class="enabled_msg">
            <span v-if="nextYearEnabled">&#10004;</span>
            <span v-else>&#10007;</span>
            Next year: {{ nextYearMessage }}
          </li>
        </div>
      </ul>

      <div class="student-h3">ID Information:</div>
      <ul id="id-section">
        <li><i class="fas fa-user"> </i> Student ID: {{ id }}</li>
      </ul>

      <div class="student-h3">Degree Information:</div>
      <ul id="stage-section">
        <li><i class="fas fa-book"></i> Degree Title: {{ progTitle }}</li>
        <li><i class="fas fa-book"></i> Detected Stage: {{ stage }}</li>
        <li><i class="fas fa-book"></i> Entry year: {{ entry_year }}</li>
      </ul>

      <div class="student-h3">Status Information:</div>
      <ul id="status-section">
        <li v-bind:style="{
                backgroundColor: statusColor,
                borderColor: '#1F2937',
              }">
          <i class="fas fa-hourglass-half"> </i>
          Status of latest choices: {{ status }}
        </li>
      </ul>

      <div
        class="block md:grid"
        :style="[
          userModTitles.length > 0
            ? {'grid-template-columns': 'repeat(2, minmax(0, 1fr));'}
            : {'grid-template-columns': 'repeat(1, minmax(0, 1fr));'},
        ]"
      >
        <!-- LDAP Registrations -->
        <div>
          <div class="student-h3">Module registrations:</div>
          <ul v-if="LDAPModTitles.length > 0" id="module-section">
            <li v-for="module in LDAPModTitles" :key="module.mod_code">
              <i class="fas fa-book-reader"></i>
              {{ module.mod_code }} - {{ module.title }}
            </li>
          </ul>
          <ul v-else id="module-section">
            <li>
              <i class="fas fa-info-circle"></i>
              Please check Campus Connect for your current module
              registrations.
            </li>
          </ul>
        </div>
        <!-- Requested modules -->
        <div v-if="userModTitles.length > 0">
          <div class="student-h3">Modules requested:</div>
          <ul id="module-section">
            <li
              v-for="module in userModTitles"
              :key="module.mod_code"
              v-bind:style="{
                backgroundColor: statusColor,
                borderColor: '#1F2937',
              }"
            >
              <i class="fas fa-book-reader"></i>
              {{ module.mod_code }} - {{ module.title }}
            </li>
          </ul>
        </div>
      </div>

      <div class="student-h3">Comments:</div>
      <ul id="comments-section">
        <li v-bind:style="{
                backgroundColor: statusColor,
                borderColor: '#1F2937',
              }">
          <i class="fas fa-comment"></i>
          {{ comments }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    progTitle: '',
    /* Retrieved from local storage */
    entry_year: localStorage.getItem('whenCreated'),
    stage: localStorage.getItem('stage'),
    id: localStorage.getItem('sn'),
    email: localStorage.getItem('user'),
    /* The modules from the LDAP storage */
    LDAPModules: localStorage.getItem('ldapRegistrations').split(','),
    LDAPModTitles: [],
    /* The module choices from the user request */
    userModuleChoices: [],
    userModTitles: [],
    /* Status and comments */
    status: 'NONE',
    statusColor: '#F3F4F6',
    comments: '',
    currentYearEnabled: false,
    nextYearEnabled: false,
    noProgramme : localStorage.getItem('prog') == 0,
    currentYearMessage: '',
    nextYearMessage: '',
  }),
  mounted() {
    /**
     * Gets the program title.
     */
    this.$axios
      .post(
        `${process.env.VUE_APP_API_URL}/get_degree_title`,
        {
          email: `${this.email}`,
          jwt: localStorage.getItem('jwt'),
        },
      )
      .then((response) => {
        // console.log('Degree Title');
        // console.log(response);
        this.progTitle = response.data.data
      })
      .catch((error) => console.log(error))

    /* Get user module choices */
    this.getUserRequestDetails()
    this.getSelectionsEnabled()
  },
  methods: {
    getSelectionsEnabled: function() {
      fetch(
        `${process.env.VUE_APP_API_URL}/get_enabled_selections`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            jwt: localStorage.getItem('jwt'),
          }),
        },
      )
        .then((r) => {
          return r.json();
        })
        .then((response) => {
          console.log(response.data);
          const enableGlobal = (
            response.data[0].module_selection_enabled
            && !self.noProgramme
          )
          const enableCurrent = response.data[0].current_year_enabled
          const enableNext = response.data[0].next_year_enabled

          // Set messages if they exist in the response
          const currentYearMessage = response.data[0].current_year_message
          const nextYearMessage = response.data[0].next_year_message

          this.currentYearEnabled = enableGlobal && enableCurrent
          this.nextYearEnabled = enableGlobal && enableNext

          if (this.currentYearEnabled) {
            this.currentYearMessage = "Enabled"
          } else if (currentYearMessage && currentYearMessage.length > 0) {
            this.currentYearMessage = currentYearMessage
          } else {
            this.currentYearMessage = "Disabled"
          }

          if (this.nextYearEnabled) {
            this.nextYearMessage = "Enabled"
          } else if (nextYearMessage && nextYearMessage.length > 0) {
            this.nextYearMessage = nextYearMessage
          } else {
            this.nextYearMessage = "Disabled"
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    /**
     * Gets the titles of the modules
     * @param {String} modCodes - list of module codes to get titles from.
     * @return {*} titles - array of titles if found.
     */
    async getModuleTitles(modCodes) {
      // console.log(modCodes);
      let titles = [];
      await this.$axios
        .post(
          `${process.env.VUE_APP_API_URL}/get_title_from_modcode`,
          {
            mod_code: `{${modCodes}}`,
            jwt: localStorage.getItem('jwt'),
          },
        )
        .then((response) => {
          titles = response.data.data;
        })
        .catch((error) => console.log(error));
      // console.log('modules titles');
      // console.log(titles);
      return titles;
    },

    /**
     * Gets the student's current selected modules, status and comments
     */
    async getUserRequestDetails() {
      // Stores the requested data from backend.
      let requestData = [];
      // Stores whether the request was successful or not.
      let res = false;

      /* Gets the user module request, if any exists */
      await this.$axios
        .post(
          `${process.env.VUE_APP_API_URL}/get_current_mod_choices`,
          {
            email: localStorage.getItem('user'),
            jwt: localStorage.getItem('jwt'),
          },
        )
        .then((response) => {
          if (response.data.success && response.data.data != null) {
            console.log('Response: Current modules');
            console.log(response.data.data[0]);
            requestData = response.data.data[0];
            res = true;
          }
        })
        .catch((error) => console.log(error));

      try {
        /* Gets the module title and the module code of LDAP registrations */
        this.LDAPModTitles = await this.getModuleTitles(this.LDAPModules);

        if (res && requestData) {
          this.userModuleChoices = requestData.added_choices.split(',');
          /* Get module codes and module titles of the requested modules */
          this.userModTitles = await this.getModuleTitles(
            this.userModuleChoices,
          );
          /* Get module request comments */
          this.comments = requestData.comment;

          if (requestData.accepted && requestData.dealt_with) {
            /* Request has been accepted by offce - status is green */
            this.status = 'ACCEPTED';
            this.statusColor = '#D1FAE5';
          } else if (!requestData.accepted && requestData.dealt_with) {
            /* Request has been rejected by office - status is red */
            this.status = 'REJECTED';
            this.statusColor = '#FECACA';
          } else if (!requestData.accepted && !requestData.dealt_with) {
            /* Request has not been dealt with by office - status is yellow */
            this.status = 'PENDING';
            this.statusColor = '#FEF3C7';
          }
        } else {
          /* User has no request - status is white */
          this.status = 'NONE';
          this.statusColor = '#F3F4F6';
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style scoped>
.enabled_msg {
  white-space: normal;
}
</style>
